import { get } from 'lodash';

const percentile = (values: number[], p: number) => {
  const sorted = [...values].sort((a, b) => a - b);
  const index = Math.ceil((p / 100) * sorted.length) - 1;
  return sorted[Math.max(0, index)];
};

const contentLength = (value: unknown, unit?: string) => {
  if (unit === undefined) {
    return String(value).length;
  }
  if (value === null || value === undefined) {
    return 1;
  }
  const formatted = typeof value === 'number' ? value.toLocaleString('sv-SE') : String(value);
  return formatted.length + unit.length;
};

export const calcMinSize = (
  path: string,
  data: object[],
  columnHeader: string,
  hasDelta: boolean = false,
  unit?: string,
) => {
  const isDelta = path.includes(':delta');
  const multiply = isDelta ? 4 : hasDelta ? 5 : 6;
  const _add = isDelta ? 40 : hasDelta ? 64 : 104;

  const contentLengths = data.map((d) => contentLength(get(d, path), unit));
  const length = percentile(contentLengths, 90);

  return Math.max(length, columnHeader.length) * multiply + _add;
};

export const calcMaxSize = (
  path: string,
  data: object[],
  columnHeader: string,
  hasDelta: boolean = false,
  unit?: string,
) => {
  if (hasDelta) {
    return 100;
  }

  const isDelta = path.includes(':delta');
  const multiply = isDelta ? 4 : 6;
  const _add = isDelta ? 40 : 104;

  const maxContentLength = Math.max(...data.map((d) => contentLength(get(d, path), unit)), columnHeader.length);

  return maxContentLength * multiply + _add;
};
